import { DOMParser, Fragment, Schema } from 'prosemirror-model'

/*
 * Parse an HTML string into a Prosemirror Fragment.
 * The returned fragment will always contain a paragraph wrapping any root text
 * content of the html string.
 */
export const parseHTMLStringToFragment = (htmlString: string, schema: Schema): Fragment => {
  let domNode = document.createElement('div')
  domNode.innerHTML = htmlString
  const doc = DOMParser.fromSchema(schema).parse(domNode)
  return doc.content
}
